"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DatePicker = DatePicker;
var _react = require("react");
var _hooks = require("../../../hooks");
var _dates = require("../../../utilities/dates");
var _Menu = require("../../Menu");
var _InlineView = require("./partials/InlineView");
var _DateTimePickers = require("../DateTimePickers.labels");
var _DateTimePickers2 = _interopRequireDefault(require("../DateTimePickers.styles"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const getValidProps = props => {
  const {
    minDate: minDateProp,
    maxDate: maxDateProp,
    selectedDate: selectedDateProp
  } = props;
  let minDate = minDateProp && maxDateProp && minDateProp > maxDateProp ? maxDateProp : minDateProp;
  let selectedDate = selectedDateProp ? new Date(selectedDateProp) : undefined;
  return {
    ...props,
    minDate,
    selectedDate
  };
};
function DatePicker(props) {
  const validProps = getValidProps(props);
  const {
    view = 'inline',
    isDisabled = false,
    minDate,
    maxDate,
    selectedDate,
    btnProps,
    anchorSubText,
    onChange
  } = validProps;
  const {
    isMobileView
  } = (0, _hooks.useDeviceData)();
  const getLabel = (0, _hooks.useLabels)({
    labels: _DateTimePickers.labels
  });
  const styles = (0, _DateTimePickers2.default)(props);
  const selectedDateTimestamp = (0, _react.useRef)(selectedDate?.getTime());
  const [currentSelectedDate, setCurrentSelectedDate] = (0, _react.useState)(selectedDate);
  const handleConfirm = () => {
    onChange(currentSelectedDate ?? new Date());
  };
  const handleCancel = () => {
    setCurrentSelectedDate(selectedDate);
  };
  const handleDateChange = date => {
    if (isDisabled) {
      return;
    }
    if (date) {
      if (date !== selectedDate) {
        date = (0, _dates.getStartOfTheDay)(date);
      }
      date = (0, _dates.restrictToMinDate)(date, minDate);
      date = (0, _dates.restrictToMaxDate)(date, maxDate);
      if (view === 'inline') {
        onChange(date);
      } else {
        setCurrentSelectedDate(date);
      }
    }
  };
  (0, _react.useEffect)(() => {
    if (selectedDateTimestamp.current !== selectedDate?.getTime()) {
      selectedDateTimestamp.current = selectedDate?.getTime();
      setCurrentSelectedDate(selectedDate);
    }
  }, [selectedDate]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: view === 'inline' ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_InlineView.InlineView, {
      ...validProps,
      isDisabled: isDisabled,
      onChange: handleDateChange
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Menu.Menu, {
      btnProps: {
        color: 'basic',
        view: 'outlined',
        shape: isMobileView ? 'roundedRectangle' : 'ellipse',
        customStyle: isMobileView ? {
          width: '100%'
        } : {
          width: 'auto'
        },
        isDisabled,
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: styles['cc-DatePicker__anchor-btn'],
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            children: selectedDate && /*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
              children: (0, _dates.formatDate)(selectedDate, '{day}.{month}.{year}')
            })
          }), anchorSubText && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            children: anchorSubText
          })]
        }),
        ...btnProps
      },
      defaultTitle: getLabel('choose_date'),
      isBoxCenteredToAnchor: true,
      anchorWidth: isMobileView ? 'auto' : 'fit-content',
      isWithActionButtons: true,
      isFullScreen: isMobileView,
      onConfirm: handleConfirm,
      onCancel: handleCancel,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_InlineView.InlineView, {
        ...validProps,
        isDisabled: isDisabled,
        selectedDate: currentSelectedDate,
        onChange: handleDateChange
      })
    })
  });
}